export default "__VITE_ASSET__2ee203c7__"